import { useMutation, useQueryClient } from "react-query";
import { useAccessToken } from "hooks/useAccessToken";
import useAlert from "hooks/useAlert";
import mutationFn from "../ApiLayer/remodelBuildingModels";

export const useRemodelBuildingModels = (onSuccess?: () => void) => {
    const accessToken = useAccessToken();
    const queryClient = useQueryClient();
    const alert = useAlert();

    return useMutation({
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ["report"],
            });
            queryClient.invalidateQueries({
                queryKey: ["buildingModelsTable"],
            });
            alert.success("Your buildings have been submitted for remodelling. Please allow up to several minutes.");

            if (onSuccess) onSuccess();
        },
        onError: (error: Error) => {
            alert.error(error.message);
        },
        mutationFn: async (buildingModelUids: string[]) => mutationFn(accessToken, buildingModelUids),
    });
};
